import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SSOProvider } from '../../../types/login/SSO';
import { SSOLoginBusinessService } from '../login/business-service/sso-login-business';
import { AuthCallbackComponent } from '../components/auth-callback/auth-callback.component';

@Component({
  selector: 'app-sso-callback',
  template: '<app-auth-callback />',
  providers: [SSOLoginBusinessService],
  imports: [AuthCallbackComponent],
})
export class SsoCallbackComponent implements OnInit {
  public static readonly SSO_CALLBACK_PATH = 'callback';

  public constructor(
    private readonly route: ActivatedRoute,
    private readonly sso: SSOLoginBusinessService,
  ) {}

  public ngOnInit(): void {
    const urlState = this.route.snapshot.queryParamMap.get('state');
    this.sso.handleAuthorizationCallback(this.detectConfigId(urlState));
  }

  private getStoredProviderState(provider: SSOProvider): Record<string, unknown> {
    const raw = sessionStorage.getItem(provider);

    if (raw === null) {
      return {};
    }

    try {
      return JSON.parse(raw) as Record<string, unknown>;
    } catch {
      return {};
    }
  }

  private detectConfigId(urlState: string | null): SSOProvider | undefined {
    if (!urlState) {
      return undefined;
    }
    for (const provider of Object.values(SSOProvider)) {
      const stored = this.getStoredProviderState(provider);
      if (stored.authStateControl === urlState) {
        return provider;
      }
    }
    return undefined;
  }
}
